// import $ from 'jquery'
import { NumberToLetter } from 'convertir-nombre-lettre';
import FileUpload from '@/components/file-upload'
import store_assurance from '@/store/mods/parametres/assurance'
import store_operation from "@/store/mods/caisse/operations"
import store_compte from '@/store/mods/caisse/compte.js'

export default {
    name: 'manage-action-creance-assurance',
    components: {
        FileUpload
    },
    props: {
        selected_facture: {
            type: Object,
            default: () => {}
        },
        action_toggler: {
            type: Number,
            default: 0
        },
        selected_facture_detail: {
            type: Array,
            default: () => []
        },
        detail_toggler: {
            type: Number,
            default: 0
        },
        historique_toggler: {
            type: Number,
            default: 0
        },
        payment_toggler: {
            type: Number,
            default: 0
        },
        current_date_filter: {
            type: Object,
            default: () => {}
        },
        is_month: {
            type: Boolean,
            default: false
        },
        is_assurance_bill: {
            type: Boolean,
            default: true
        },
        user_info: {
            type: Object,
            default: () => {}
        },
        is_facture: {
            type: Number,
            default: 0
        },
        type_facture: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            is_confirm: false,
            is_error: false,
            montant_en_lettre: '',
            date_action: new Date(Date.now() - new Date().getTimezoneOffset()*60000).toISOString().slice(0,16),
            file_upload: null,
            commentaire: '',
            montant_paye: '',

            view_patients: [],
            view_by_societe: [],

            fields: [
                { key: 'date', label: 'Date' },
                { key: 'patient', label: 'Patient' },
                { key: 'num_bon', label: 'Numéro du bon' },
                { key: 'sum_part_assureur', label: 'Total Part Assureur' }
            ],

            field_patients: [
                { key: 'date', label: 'Date' },
                { key: 'prestation', label: 'Prestation' },
                { key: 'pu', label: 'Prix unitaire' },
                { key: 'qte', label: 'Qte' },
                { key: 'part_assureur', label: 'Part Assureur' }
            ],

            fields_suivi_facture: [
                { key: 'evt', label: 'Évènement' },
                { key: 'auteur', label: 'Auteur' },
                { key: 'date', label: 'Date' },
                { key: 'commentaire', label: 'Commentaire' },
                { key: 'preuve', label: 'Preuve' }
            ],

            search_filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            type_view: 'by_societe',
            total_facture: 0,
            total_en_lettre: '',
            view_types: [
                { slug: 'by_societe', libelle: 'Par société' },
                { slug: 'by_patient', libelle: 'Par patient' }
            ],
            selected_view_type: { slug: 'by_societe', libelle: 'Par société' },
            is_suffixe: 0,
            msg_error: '',
            save_loading: false,
            info_societe: null,
            historique_facture: [],
            is_empty: false,
            is_loading: true,
            attach_file_viewer: false,
            can_preview: false,
            filename: '',

            banques: [],
            compte_destinations: [
                { id: 6, libelle: 'Compte de dépôt' },
                { id: -1, libelle: 'Banque' }
            ],
            selected_compte: null,
            selected_banque: null,
            can_show_banque: false,
            can_print: false,
            final_selected_compte: null,
            is_ecart: false,
            must_justify: false,
            ecart: 0
        }
    },

    watch: {
        action_toggler() {
            this.clearError()
            if (this.selected_facture.sum_part_assureur && this.selected_facture.sum_part_assureur > 0) {
                this.montant_en_lettre = NumberToLetter(this.selected_facture.sum_part_assureur)
            }

            this.info_societe = null
            this.date_action = new Date(Date.now() - new Date().getTimezoneOffset()*60000).toISOString().slice(0,16)
            if (this.is_assurance_bill === false) {
                this.fetchSocietInfoByID()
            }
        },

        detail_toggler() {
            this.view_by_societe = []
            this.view_patients = []
            this.selected_view_type = { slug: 'by_societe', libelle: 'Par société' }

            this.total_facture = this.selected_facture.sum_part_assureur
            this.total_en_lettre = NumberToLetter(this.total_facture)
            // this.setViewPatient()
            this.setViewPatientBySociete()
        },

        selected_view_type() {
            if (this.selected_view_type.slug == 'by_societe') {
                this.setViewPatientBySociete()
            } else {
                this.setViewPatient()
            }
        },

        historique_toggler() {
            this.attach_file_viewer = false
            this.fetchSuiviAssurance()
        },
        
        payment_toggler() {
            this.date_action = new Date(Date.now() - new Date().getTimezoneOffset()*60000).toISOString().slice(0,16)
            this.clearError()
            if (this.selected_facture.sum_part_assureur && this.selected_facture.sum_part_assureur > 0) {
                this.montant_en_lettre = NumberToLetter(this.selected_facture.sum_part_assureur)
            }
            this.fetchBanques() 
            
            this.$refs.pay_form.reset()
        },

        selected_compte() {
            this.msg_error = ''
            this.can_show_banque = false
            if (this.selected_compte.id == -1) {
                this.can_show_banque = true
            }

            this.final_selected_compte = (this.selected_compte.id != -1)?this.selected_compte:this.selected_banque
        },

        commentaire() {
            this.must_justify = false
        },

        montant_paye() {
            this.msg_error = ''
        }
    },

    computed: {

    },

    mounted() {
        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },
    
    methods: {
        clearError() {
            this.file_upload = null
            this.commentaire = ''
            this.montant_paye = ''
            this.selected_compte = null
            this.selected_banque = null
            this.can_show_banque = false
            this.is_ecart = false
            this.must_justify = false

            this.is_confirm = false
            this.msg_error = ''
            let cfrm = document.getElementById('cfrm-arr') 
            if (cfrm && cfrm.checked) {
                cfrm.checked = false
            }
        },

        fetchBanques() {
            this.is_loading = true

            store_compte.getCompteBanque().then((response) => {
                this.banques = response.data
                this.is_loading = false
            })
        },

        fetchSuiviAssurance() {
            this.is_error = false
            this.is_loading = true
            const data = {
                facture_id: this.selected_facture.facture_id
            }
            store_operation.getSuiviFactureAssurance(data).then((response) => {
                this.historique_facture = response
                if (this.historique_facture.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        fetchSocietInfoByID() {
            store_assurance.getInfoSocieteByID(this.selected_facture.souscripteur_id).then((response) => {
                if (response.success) {
                    this.info_societe = response.data
                }
            })
        },

        setViewPatientBySociete() {
            const tmp_grouped_patients_by_societe = this.selected_facture_detail.groupBy('souscripteur')
            this.view_by_societe = []

            for (const key in tmp_grouped_patients_by_societe) {
                let sum_part_assureur = 0
                tmp_grouped_patients_by_societe[key].forEach(el => {
                    sum_part_assureur += el.part_assureur
                });

                // Group by patient
                const tmp_grouped_patients = tmp_grouped_patients_by_societe[key].groupBy('patient')
                let patients = []
                for (const key_patient in tmp_grouped_patients) {
                    let sum_part_assureur_patient = 0
                    tmp_grouped_patients[key_patient].forEach(el => {
                        sum_part_assureur_patient += el.part_assureur
                    });

                    // get last index date_creance
                    const operations_len = tmp_grouped_patients[key_patient].length
                    const last_operation = tmp_grouped_patients[key_patient][operations_len - 1]
                    const date_creance = last_operation.date_creance

                    const tmp_group_patient = {
                        patient: key_patient,
                        sum_part_assureur: sum_part_assureur_patient,
                        operations: tmp_grouped_patients[key_patient],
                        date_creance: date_creance
                    }
                    patients.push(tmp_group_patient)
                }

                const tmp_group = {
                    societe: key,
                    sum_part_assureur: sum_part_assureur,
                    patients: patients
                }
                this.view_by_societe.push(tmp_group)
            }
            
        },

        setViewPatient() {
            const tmp_grouped_patients = this.selected_facture_detail.groupBy('patient')
            this.view_patients = []

            for (const key in tmp_grouped_patients) {
                let sum_part_assureur = 0
                let operations_len = tmp_grouped_patients[key].length
                tmp_grouped_patients[key].forEach(el => {
                    sum_part_assureur += el.part_assureur
                });

                // get last index date_creance
                const last_operation = tmp_grouped_patients[key][operations_len - 1]
                const date_creance = last_operation.date_creance

                const tmp_group = {
                    patient: key,
                    sum_part_assureur: sum_part_assureur,
                    operations: tmp_grouped_patients[key],
                    date_creance: date_creance
                }
                this.view_patients.push(tmp_group)
            }
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            this.msg_error = ''
        },

        setVmodel(response) {
            this.file_upload = response.u_file
        },

        arreterFacture(selector) {
            const confirm = document.getElementById(selector);
            if (!confirm.checked) { 
                this.msg_error = "Veuillez confirmer l'arrêt de la facture en cochant la case de confirmation."
                return
            }

            let periode = ''
            if (this.is_month) {
                periode = 'Période du mois de ' + this.current_date_filter.libelle_month
            } else {
                if (this.current_date_filter.one_date != '') {
                    periode = 'Période du ' + this.formatDateToDmY(this.current_date_filter.one_date)
                } else {
                    periode = `Période du ${this.formatDateToDmY(this.current_date_filter.from_date)} au ${this.formatDateToDmY(this.current_date_filter.to_date)}`
                }
            }

            // Go through selected_facture_detail and get only the id into operations
            const operations = this.selected_facture_detail.map(item => ({id: item.id}))

            const data = {
                assurance_id: this.selected_facture.assurance_id,
                assurance: this.selected_facture.assurance,
                societe_id: (this.selected_facture.souscripteur)?this.selected_facture.souscripteur_id:null,
                societe: (this.selected_facture.souscripteur)?this.selected_facture.souscripteur:null,
                data_type: 'remboursement_assurance',
                is_assurance: (this.is_assurance_bill === true)?1:0,
                etat: 1,
                user_id: this.user_info.user_id,
                user: this.user_info.name,
                montant: parseInt(this.selected_facture.sum_part_assureur),
                periode: periode,
                info_societe: this.info_societe,
                selected_date: {
                    month: this.current_date_filter.month,
                    from_date: this.current_date_filter.from_date,
                    to_date: this.current_date_filter.to_date,
                    one_date: this.current_date_filter.one_date
                },
                operations: operations
            }
            
            this.save_loading = true
            store_operation.arreterFactureAssuranceSociete(data).then((response) => {
                if (response.success) {
                    this.$refs.arret_facture.click()
                    this.successToast(response.message)

                    this.$emit("emitRefreshListeCreanceAssurance")
                    this.$emit('emitGotoFacture')   
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        async gererEtatFacture(selector, etat) {
            this.ecart = 0
            if (etat == '4') {
                const isValid = await this.$refs.pay_form.validate();
                if (!isValid) {
                    this.msg_error = 'Merci de remplir tous les champs requis * !'
                    return;
                }

                if (this.selected_facture.sum_part_assureur < this.montant_paye) {
                    this.msg_error = 'Le montant reçu doit être inférieur ou égale au montant dû !'
                    return;
                }

                if (
                    this.selected_facture.sum_part_assureur != this.montant_paye
                ) {
                    this.is_ecart = true
                    const mnt_recu = parseInt(this.montant_paye)
                    this.ecart = this.selected_facture.sum_part_assureur - mnt_recu

                    if (this.commentaire == '') {
                        this.must_justify = true
                        this.is_confirm = false
                        return;
                    }
                }


            }

            if (!this.is_confirm) {
                this.is_confirm = true
                return;
            }

            const confirm = document.getElementById(selector);
            if (!confirm.checked) { 
                if (etat == '2') {
                    this.msg_error = "Veuillez confirmer le dépôt de la facture en cochant la case de confirmation."
                } else if (etat == '3') {
                    this.msg_error = "Veuillez confirmer la relance de la facture en cochant la case de confirmation."
                } else if (etat == '4') {
                    this.msg_error = "Veuillez confirmer le paiement de la facture en cochant la case de confirmation."
                }
                
                return
            }

            let data_type = ''
            let final_selected_compte = null
            if (etat == '2') {
                data_type = 'depot'
            } else if (etat == '3') {
                data_type = 'relance'
            } else if (etat == '4') {
                data_type = 'paiement'
                final_selected_compte = (this.selected_compte.id != -1)?this.selected_compte:this.selected_banque
            }

            const data = {
                facture_id: this.selected_facture.facture_id,
                facture_ref: this.selected_facture.reference,
                data_type: data_type,
                user_id: this.user_info.user_id,
                user: this.user_info.name,
                user_titre: this.user_info.titre,
                date: this.date_action,
                commentaire: this.commentaire,
                montant_du: this.selected_facture.sum_part_assureur,
                montant_paye: (this.montant_paye > 0)?parseInt(this.montant_paye):null,
                selected_compte: final_selected_compte,
                etat: parseInt(etat)
            }
            console.log("data ",data);
            

            let form_data = new FormData();
            for (let key in data) {
                if (typeof(data[key]) != 'object') {
                    form_data.append(key, data[key])
                } else {
                    form_data.append(key, JSON.stringify(data[key]));
                }
            }
            form_data.append('preuve', this.file_upload);

            this.save_loading = true
            store_operation.manageFactureAssuranceSociete(form_data).then((response) => {
                if (response.success) {
                    if (etat == '2') {
                        this.$refs.depot_facture.click()
                    } else if (etat == '3') {
                        this.$refs.relance_facture.click()
                    } else if (etat == '4') {
                        this.$refs.paiement_facture.click()
                    }
                    
                    this.successToast(response.message)
                    if (this.type_facture == 'facture_assurance') {
                        this.$emit("emitRefreshFacture") 
                    } else {
                        this.$emit("emitRefreshFactureForafait") 
                    }
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        viewProof(filename) {
            this.can_preview = this.checkIfCanPreview(filename)

            this.filename = this.assets_path + '/files/preuves/'+filename

            this.attach_file_viewer = true
        },

        backToHistorique() {
            this.attach_file_viewer = false
        },

        setPrintInvoice() {
            const invoice_data = {
                is_assurance_bill: this.is_assurance_bill,
                selected_facture: this.selected_facture,
                view_by_societe: this.view_by_societe,
                view_patients: this.view_patients,
                total_facture: this.total_facture,
                total_en_lettre: this.total_en_lettre,
                selected_view: this.selected_view_type.slug,
                periode: this.selected_facture.periode,
                date: this.selected_facture.date
            }

            this.$emit('emitSetInvoiceToPrint', invoice_data) 
        }
    }
}